import { api } from "../../../api/apiSlice";

export const holidaysApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getHolidays: builder.query({
      query: () => ({ url: "/masters/holidays" }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((h) => ({ type: "HrHolidays", id: h.id })),
              { type: "HrHolidays", id: "LIST" },
            ]
          : [{ type: "HrHolidays", id: "LIST" }],
    }),
    createHoliday: builder.mutation({
      query: (body) => ({ url: "/masters/holidays", method: "POST", data: body }),
      invalidatesTags: [{ type: "HrHolidays", id: "LIST" }],
    }),
    updateHoliday: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/masters/holidays/${id}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: [{ type: "HrHolidays", id: "LIST" }],
    }),
    deleteHoliday: builder.mutation({
      query: (id) => ({ url: `/masters/holidays/${id}`, method: "DELETE" }),
      invalidatesTags: [{ type: "HrHolidays", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetHolidaysQuery,
  useCreateHolidayMutation,
  useUpdateHolidayMutation,
  useDeleteHolidayMutation,
} = holidaysApi;
